import React from 'react';
import LoginDropdown from './login-dropdown';
import AniLink from "gatsby-plugin-transition-link/AniLink"
import SmoothScrollLink from '../../transition/smooth-scroll-link';

interface Props {
  ctaColor: 'amethist' | 'sky' | 'fern' | 'amber',
  ctaLink: string,
  ctaText: string,
  experimentA?: boolean
}

const ButtonsContainer = ({ ctaColor, ctaLink, ctaText, experimentA = false }: Props) => {
  const isScrollLink = ctaLink?.includes('#');

  return (
    <div className='buttons-container'>
      {experimentA === false && <LoginDropdown />}
      { isScrollLink ?
        <SmoothScrollLink offset={100} offsetMobile={0} id={ctaLink}><button className={`rula-button ${ctaColor}`}>{ctaText}</button></SmoothScrollLink> :
        <AniLink href={ctaLink}><button className={`rula-button ${ctaColor}`}>{ctaText}</button></AniLink>
      }
    </div>
  )
}

export default ButtonsContainer;
